import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_success",
  "use": "icon-i_success-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_success\"><title>icon_画板</title><path d=\"M23.24,12.14l-7.23,8a1.31,1.31,0,0,1-1.84,0L10.8,16A.83.83,0,0,0,9.51,17l3.43,4.19a3,3,0,0,0,4.28.06l7.25-8a.84.84,0,0,0,0-1.18.85.85,0,0,0-1.18.06Z\" /><path d=\"M17,31.54A14.53,14.53,0,1,1,17,2.48,14.43,14.43,0,0,1,27.28,6.73h0A14.54,14.54,0,0,1,17,31.54ZM17,4.71a12.29,12.29,0,1,0,8.69,3.6h0A12.22,12.22,0,0,0,17,4.71Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol